import React from "react";
import { ClienteDto } from "../../generated"
import { addressDescription } from "./customerForm"
import { MapLink } from "../../common/components/MapLink";
import { Link } from "../../common/components/link";
import { links } from "../../routes";
import { PhoneComponents } from "../../common/components/PhoneComponent";

interface Props {
    customer: ClienteDto;
}

export default class CustomerSheet extends React.Component<Props> {
    render() {
        const { customer } = this.props;
        return (
            <>
                <div className="card">
                    <div className="card-header d-flex align-items-center justify-content-between bg-theme text-white">
                        <div><i className="fas fa-id-card fa-2x" /></div>
                        <div style={{ fontSize: "1.5rem", textDecoration: customer.dismessa ? "line-through" : undefined }} className={customer.dismessa ? "badge bg-danger" : ""}>{customer.cognomeProprietario} {customer.nomeProprietario}</div>
                        <div>Id:<span className="ms-2" style={{ fontSize: "1.3rem" }}>{customer.codiceClienteAzienda}</span></div>
                    </div>
                    <CustomerSheetBody customer={customer} />
                </div>
                {customer.notaCliente &&
                    <div className="alert alert-warning mb-4 shadow">
                        <div className="text-uppercase fw-bold" style={{ fontSize: "0.8rem" }}>note cliente:</div>
                        <div>{customer.notaCliente}</div>

                    </div>
                }
            </>);
    }
}


export const CustomerSheetBody: React.FunctionComponent<{ customer: ClienteDto }> = ({ customer }) => {
    return (
        <>
            <div className="card-body p-0 mt-2">
                <div className="d-flex justify-content-around flex-wrap">
                    {customer.responsabile &&
                        <div className="d-flex align-items-center">
                            <div className="me-2">
                                <i className="fas fa-asterisk text-warning fa-lg" />
                            </div>
                            <div>
                                <div className="text-uppercase fw-bold" style={{ fontSize: "0.8rem" }}>responsabile:</div>
                                <div>{customer.responsabile}</div>
                            </div>
                        </div>
                    }
                    <div className="d-flex align-items-center justify-content-center">
                        <div className="me-2">
                            <i className="far fa-map fa-lg" />
                        </div>
                        <div>
                            <div style={{ fontSize: "0.8rem" }} className="text-uppercase fw-bold">
                                indirizzo:
                            </div>
                            <MapLink
                                hideIcon
                                text={addressDescription(customer)}
                                query={customer.latitudine && customer.longitudine
                                    ? {
                                        lat: customer.latitudine,
                                        lng: customer.longitudine
                                    }
                                    : addressDescription(customer)
                                }
                            />
                            {customer.piano && <span className="ms-3">Piano: <strong>{customer.piano}</strong></span>}
                        </div>
                    </div>
                </div>
                <div className="w-100 mt-2 mb-2" style={{ borderBottom: "1px solid rgba(0,0,0,.125)" }}></div>
                <div className="p-2 d-flex flex-wrap justify-content-center">
                    {customer.telefono &&
                        <div className="d-flex align-items-center me-3">
                            <div className="me-2">
                                <i className="fas fa-phone fa-lg" />
                            </div>
                            <div>
                                <div className="text-uppercase fw-bold" style={{ fontSize: "0.8rem" }}>Telefono:</div>
                                <PhoneComponents tel={customer.telefono} />
                            </div>
                        </div>}
                    {customer.cell &&
                        <div className="d-flex align-items-center me-3">
                            <div className="me-2">
                                <i className="fas fa-mobile-alt fa-lg" />
                            </div>
                            <div>
                                <div className="text-uppercase fw-bold" style={{ fontSize: "0.8rem" }}>tel.mobile:</div>
                                <PhoneComponents tel={customer.cell} showWhatsApp />
                            </div>
                        </div>
                    }
                    {customer.email &&
                        <div className="d-flex align-items-center me-3">
                            <div className="me-2">
                                <i className="fas fa-at fa-lg" />
                            </div>
                            <div>
                                <div className="text-uppercase fw-bold" style={{ fontSize: "0.8rem" }}>email:</div>
                                <a className="text-lowercase" href={"mailto:" + customer.email}>{customer.email}</a>
                            </div>
                        </div>
                    }
                    {
                        customer.fax &&
                        <div className="d-flex align-items-center me-3">
                            <div className="me-2">
                                <i className="fas fa-fax fa-lg" />
                            </div>
                            <div>
                                <div className="text-uppercase fw-bold" style={{ fontSize: "0.8rem" }}>fax:</div>
                                <a className="text-lowercase" href={"tel:" + customer.fax}>{customer.fax}</a>
                            </div>
                        </div>
                    }
                </div>
                {
                    (customer.codiceFiscale || customer.partitaIva || customer.pec || customer.sdi) &&
                    <>
                        <div className="w-100 mt-2 mb-2" style={{ borderBottom: "1px solid rgba(0,0,0,.125)" }}></div>
                        <div className="d-flex justify-content-center flex-wrap mb-2">
                            {
                                customer.codiceFiscale &&
                                <div className="me-3">
                                    <div className="text-uppercase fw-bold" style={{ fontSize: "0.8rem" }}>codice fiscale:</div>
                                    <div className="text-uppercase">{customer.codiceFiscale}</div>
                                </div>
                            }
                            {
                                customer.partitaIva &&
                                <div className="me-3">
                                    <div className="text-uppercase fw-bold" style={{ fontSize: "0.8rem" }}>partita iva:</div>
                                    <div className="text-uppercase">{customer.partitaIva}</div>
                                </div>
                            }
                            {
                                customer.pec &&
                                <div className="me-3">
                                    <div className="text-uppercase fw-bold" style={{ fontSize: "0.8rem" }}>pec:</div>
                                    <div className="text-uppercase">{customer.pec}</div>
                                </div>
                            }
                            {
                                customer.sdi &&
                                <div className="me-3">
                                    <div className="text-uppercase fw-bold" style={{ fontSize: "0.8rem" }}>sdi:</div>
                                    <div className="text-uppercase">{customer.sdi}</div>
                                </div>
                            }
                        </div>
                    </>
                }
            </div>
            <div className="card-footer d-flex justify-content-between">
                <Link to={links.customerEdit(customer.idCliente)} type="button" className="btn btn-outline-secondary">
                    <i className="fas fa-user-edit me-1" />  Modifica
                </Link>
            </div>

        </>
    );
}